import { Routes } from '@angular/router';
import { APP_ROUTES } from './AppRoutes';

export const appRouterConfig: Routes = [
  {
    path: '',
    redirectTo: APP_ROUTES['SUMMARY'].value,
    pathMatch: 'full'
  },

  {
    path: APP_ROUTES['SUMMARY'].value,
    loadComponent: () =>
      import('../../pages/summary-page/summary-page.component')
        .then(m => m.SummaryPageComponent)
  },

  {
    path: APP_ROUTES['SCORE_EVOLUTION'].value,
    loadComponent: () =>
      import('../../pages/age-and-score-evolution-page/age-and-score-evolution-page.component')
        .then(m => m.AgeAndScoreEvolutionPageComponent)
  },

  {
    path: APP_ROUTES['AGE_EVOLUTION'].value,
    loadComponent: () =>
      import('../../pages/age-and-score-evolution-page/age-and-score-evolution-page.component')
        .then(m => m.AgeAndScoreEvolutionPageComponent)
  },

  {
    path: `${APP_ROUTES['RAW_DATA'].value}/:${APP_ROUTES['RAW_DATA']['params'][0]}`,
    loadComponent: () =>
      import('../../pages/raw-data-page/raw-data-page.component')
        .then(m => m.RawDataPageComponent)
  },

  {
    path: `${APP_ROUTES['CATEGORY'].value}/:${APP_ROUTES['CATEGORY']['params'][0]}`,
    loadComponent: () =>
      import('../../pages/category-page/category-page.component')
        .then(m => m.CategoryPageComponent)
  },

  {
    path: APP_ROUTES['SECOND_DISPLAY'].value,
    loadComponent: () =>
      import('../../pages/second-display-page/second-display-page.component')
        .then(m => m.SecondDisplayPageComponent)
  },

  {
    path: `${APP_ROUTES['INFORMATION'].value}/:${APP_ROUTES['INFORMATION']['params'][0]}/:${APP_ROUTES['INFORMATION']['params'][1]}/:${APP_ROUTES['INFORMATION']['params'][2]}`,
    loadComponent: () =>
      import('../../pages/information-page/information-page.component')
        .then(m => m.InformationPageComponent)
  },

  {
    path: '**',
    redirectTo: APP_ROUTES['SUMMARY'].value
  }
];
